// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title__+l0T2","clickable":"SectionTitle_clickable__1WaNa"};